import { VisualCrop, VisualZoom } from 'app/frontend/types/custom/VisualPlan'

export const DEFAULT_FILL_COLOR = 'rgba(255, 255, 255, 0.3)'
export const DEFAULT_STROKE_COLOR = 'rgb(255, 255, 255)'
export const DEFAULT_STROKE_WIDTH = 2
export const DEFAULT_POINTER_SIZE = 0.02
export const DEFAULT_TEXT_COLOR = 'rgb(255, 255, 255)'
export const DEFAULT_TEXT_BACKGROUND = 'rgba(0, 0, 0, 0.5)'
export const DEFAULT_TEXT_FONT_SIZE = 0.015
export const MIN_TEXT_FONT_SIZE = 0.005
export const MAX_TEXT_FONT_SIZE = 0.03
export const TEXT_FONT_SIZE_STEP = 0.001
export const DEFAULT_LABEL_FONT_SIZE = 0.01
export const LABEL_FONT_SIZE_STEP = 0.002
export const DEFAULT_TEXT_WIDTH = 0.15
export const TEXT_PADDING_X = 8
export const TEXT_PADDING_Y = 4
export const TEXT_LINE_HEIGHT = 1.2
export const TEXT_FONT_FAMILY = 'Arial'
export const FALLBACK_ASPECT = 9 / 16
export const MIN_SIZE = 6
export const MAX_ENTITY_COUNT = 30
export const ZOOM_MIN = 1
export const ZOOM_MAX = 3
export const ZOOM_STEP = 0.1
export const ZOOM_WHEEL_STEP = 0.04
export const DEFAULT_ZOOM_SCALE = 1
export const MIN_CROP_HEIGHT = 0.25

export type ShapeStyle = {
  fill_rgb: string | undefined
  stroke_rgb: string | undefined
  stroke_width: number | undefined
}

export const DEFAULT_SHAPE_STYLE: ShapeStyle = {
  fill_rgb: DEFAULT_FILL_COLOR,
  stroke_rgb: DEFAULT_STROKE_COLOR,
  stroke_width: DEFAULT_STROKE_WIDTH,
}

export const DEFAULT_ICON_SIZE = 0.04
export const DEFAULT_ENCOUNTER_ICON_SIZE = DEFAULT_ICON_SIZE * 1.4
export const DEFAULT_ICON_OPACITY = 1
export const DEFAULT_ICON_STROKE_COLOR = 'rgb(102, 102, 102)'
export const DEFAULT_ICON_STROKE_WIDTH = 2

export type IconStyle = {
  size: number
  opacity: number
  stroke_rgb?: string
  stroke_width?: number
  entity_count?: number
}

export const DEFAULT_ICON_STYLE: IconStyle = {
  size: DEFAULT_ICON_SIZE,
  opacity: DEFAULT_ICON_OPACITY,
  stroke_rgb: DEFAULT_ICON_STROKE_COLOR,
  stroke_width: DEFAULT_ICON_STROKE_WIDTH,
  entity_count: 0,
}

export const stageViewAttrs = (
  zoom: VisualZoom | undefined,
  crop: VisualCrop | undefined,
  width: number,
  fullHeight: number,
) => {
  const scale = zoom && zoom.scale > 1 ? zoom.scale : 1
  const cropH = crop && crop.height < 1 ? crop.height : 1
  const visibleHeight = fullHeight * cropH
  return {
    visibleHeight,
    scaleX: scale,
    scaleY: scale,
    x: -(zoom?.x ?? 0) * width * (scale - 1),
    y: -(
      (zoom?.y ?? 0) * fullHeight * (scale - 1) +
      (crop?.y ?? 0) * fullHeight * (1 - cropH)
    ),
  }
}

export const zoomStageAttrs = (
  zoom: VisualZoom | undefined,
  width: number,
  height: number,
) => {
  const { scaleX, scaleY, x, y } = stageViewAttrs(
    zoom,
    undefined,
    width,
    height,
  )
  return { scaleX, scaleY, x, y }
}
